import { gql } from '@apollo/client';

// GraphQL Subscription Query
export const MESSAGE_ADDED_SUBSCRIPTION = gql`
  subscription {
    messageAdded {
      id
      content
    }
  }
`;
